import React, {useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js';
const ConsPayment = (props) => {
    const {cons_id} = useParams();
    const [patientData, setPatientData] = useState([]);
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const today = new Date();
    const [opbillData, setopbillData] = useState([]);
    const [lnet, setLnet] = useState([]);
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [subtotal, setSubTotal] = useState(0);
    const [changed, setChanged] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [tds, setTds] = useState(0);
    const [pharmData, setpharmData] = useState({
        "appt": '',
        "cons": '',
        "pay_status": '',
        "pay_by": '',
        "pay_on": '',
        "pay_type": '',
        "pay_id": '',
        "pay_amount": '',
        "pay_detail": '',
        "ip_add": '',
    });
    const handleStartDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setStartDate(localDate);
    };
    const handleEndDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setEndDate(localDate);
    };
    useEffect(() => {
        fetchData();
    }, [startDate, endDate]);
    const fetchData = () => {
        // Constructing the URL with optional date filters
        const startDateString = startDate ? startDate.toISOString().substring(0, 10) : today.toISOString().substring(0, 10);
        const endDateString = endDate ? endDate.toISOString().substring(0, 10) : today.toISOString().substring(0, 10);
        if (startDateString && endDateString) {
            const url = `${baseUrl}cons-appointment-pay/?start_date=${startDateString}&end_date=${endDateString}&cons=${cons_id}&status=2`;
            axios.get(url)
                .then(response => {
                    if (Array.isArray(response.data) && response.data.length > 0) {
                        const appointments = response.data;
                        const promises = [];
                        appointments.forEach(appointment => {
                            if (appointment.id) {
                                promises.push(
                                    axios.get(baseUrl + 'pay-cons/' + appointment.id)
                                        .then(payConsResponse => {
                                            if (payConsResponse.data == '' || payConsResponse.data == null) {
                                                return appointment;
                                            } else {
                                                return null;
                                            }
                                        })
                                        .catch(error => {
                                            console.error('Error fetching pay-cons data:', error);
                                            return null; // Return null on error fetching pay-cons data
                                        })
                                );
                            } else {
                                console.log('Appointment does not have an id:', appointment);
                            }
                        });
                        Promise.all(promises)
                            .then(updatedAppointments => {
                                const filteredAppointments = updatedAppointments.filter(appointment => appointment !== null);
                                setopbillData(filteredAppointments);
                            })
                            .catch(error => {
                                console.error('Error with Promise.all:', error);
                            });
                    } else {
                        console.log('No appointments found or response data structure is incorrect:', response.data);
                    }
                })
                .catch(error => {
                    console.error('Error fetching appointment data:', error);
                });
        }
    };
    useEffect(() => {
        setRows(rows);
    }, [rows]);
    const handleKeyDown = (e, index) => {
        const newRows = [...rows];
        switch (e.keyCode) {
            case 18: // Alt key
                e.preventDefault();
                handleDeleteRow(e, index);
                break;
            default:
                break;
        }
    };
    const inputRefs = useRef([]);
    useEffect(() => {
        inputRefs.current[inputRefs.current.length - 1]?.focus();
    }, [rows.length]);
    const handleDeleteRow = (e, rowIndex) => {
        e.preventDefault();
        const newOpbillData = [...opbillData];
        newOpbillData.splice(rowIndex, 1);
        setopbillData(newOpbillData);
    };
    const handleTdsChange = (e) => {
        const newTds = parseFloat(e.target.value) || 0;
        setTds(newTds);
    };
    const handleChange = (e, index) => {
        const {name, value} = e.target;
        setpharmData(prevState => ({...prevState, [name]: value}));
    };
    const handleAmountChange = (e, subIndex) => {
        const newLnet = [...lnet];
        setLnet(newLnet);
    };
    useEffect(() => {
        let subTotal = 0;
        let newTotal = 0;
        subTotal = arraySum(lnet); // Calculate subTotal based on arraySum
        if (rows.length > 0) {
            let subTotal1 = 0;
            for (let i = 0; i < rows.length; i++) {
                const row = rows[i];
                subTotal1 += row.cons__drfees;
            }
            subTotal += subTotal1; // Add subTotal1 to the existing subTotal
        }
        newTotal = subTotal - (subTotal * tds / 100);
        setSubTotal(subTotal);
        setTotal(newTotal);
    }, [lnet, rows, tds]);
    const arraySum = (arr) => {
        return arr.reduce((total, value) => total + parseFloat(value), 0);
    };
    useEffect(() => {
        const lnetDefaultValues = [];
        opbillData.forEach((row) => {
            const lnetDefaultValue = (row.cons__drfees || 0);
            lnetDefaultValues.push(lnetDefaultValue);
        });
        setLnet(lnetDefaultValues);
    }, [opbillData]);
    const formSubmit = (e) => {
        e.preventDefault();
        const dbType = document.getElementById('dbType').value;
        const details = document.getElementById("details").value;
        if (!dbType) {
            Swal.fire('Error', 'Please select a Payment Type.', 'error');
            return;
        }
        axios.post(`${baseUrl}get_cpay_id/`)
            .then(response => {
                const pay_id = response.data.value;
                opbillData.forEach((row, index) => {
                    const id = row.id;
                    const _formData = new FormData();
                    const deductedAmount = row.cons__drfees - (row.cons__drfees * tds / 100);
                    _formData.append('pay_id', pay_id);
                    _formData.append('appt', id.toString());
                    _formData.append('cons', cons_id);
                    _formData.append('pay_amount', deductedAmount);
                    _formData.append('pay_type', dbType);
                    _formData.append('pay_detail', details);
                    _formData.append('pay_on', formattedDate);
                    _formData.append('pay_status', '1');
                    _formData.append('pay_by', userName);
                    _formData.append('ip_add', ipAddress);
                    _formData.append('location', userLocation);
                    axios.post(`${baseUrl}pay-cons/`, _formData)
                        .then(response => {
                        })
                        .catch(error => {
                            console.log(error);
                        });
                });
                Swal.fire({
                    title: 'Payment Generated.',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                setTimeout(() => {
                    window.location.href = '/cons-search/';
                }, 2000);
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to generate unique value. Please try again later.',
                    'error'
                );
            });
    };
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-calendar-days" aria-hidden="true" style={{color: 'red'}}></i> Make Consultant
                Payment
            </h3>
            <div className="row">
                <div className="col-md-6">
                    <div className="col-sm-9 col-lg-10 controls">
                        <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
                        <div className="date-filter-container">
                            <DatePicker
                                selected={startDate}
                                onChange={handleStartDateChange}
                                selectsStart
                                startDate={startDate}
                                endDate={endDate}
                                placeholderText="From Date"
                                dateFormat="dd/MM/yyyy"
                                showMonthDropdown
                                showYearDropdown
                                className="date-picker-input"
                            />

                            <DatePicker
                                selected={endDate}
                                onChange={handleEndDateChange}
                                selectsEnd
                                startDate={startDate}
                                endDate={endDate}
                                minDate={startDate}
                                placeholderText="To Date"
                                dateFormat="dd/MM/yyyy"
                                showMonthDropdown
                                showYearDropdown
                                className="date-picker-input"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <form>
                <div className="row table-responsive">
                    <div className='col-md-12 col-12 mb-2'>
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th>Consultant ID</th>
                                <th>Consultant Name</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td style={{width: '10%'}}>{opbillData[0]?.cons__cons_id}</td>
                                <td style={{width: '10%'}}>{opbillData[0]?.cons__consultant}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='table-responsive'>
                    <table className="erp-table-modern">
                        <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                            <th style={{width: 120}}>ID</th>
                            <th style={{width: 500}}>Appointment ID</th>
                            <th style={{width: 500}}>Outstanding Amount</th>
                        </tr>
                        </thead>
                    </table>
                    {opbillData.length > 0 && opbillData.map((row, index) => (
                        <div key={index}>
                            <input
                                type="text"
                                name={`id-${index}`}
                                id={`id-${index}`}
                                className="ms-1 me-4 mt-4"
                                value={row.id}
                                onChange={(e) => handleChange(e, index)}
                                style={{width: 120}}
                                tabIndex={-1}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                readOnly
                            />
                            <input
                                type="text"
                                className="ms-4 me-2"
                                style={{width: 500}}
                                name="appt_id"
                                value={row.appt_id}
                                onChange={(e) => handleChange(e, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                tabIndex={-1}
                                readOnly
                            />
                            <input
                                type="text"
                                className="ms-4 me-2"
                                style={{width: 500}}
                                name="drfees"
                                value={row.cons__drfees}
                                onChange={(e) => handleChange(e, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                tabIndex={-1}
                                readOnly
                            />
                            <button className="btn btn-danger" style={{display: 'none'}} type="button"
                                    onClick={(e) => handleDeleteRow(e, index)}>Delete
                            </button>
                        </div>
                    ))}
                    <div className="row ms-5 mt-5">
                        <div className="col-md-6">
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                                 className='ms-5'>
                                <div className="form-group">
                                    <label style={{fontWeight: 'bold'}}>Subtotal: &nbsp;</label>
                                    <div className="input-group">
                                        <div className="input-group-addon me-2">&#8377;</div>
                                        <input type="number" onChange={handleChange} value={subtotal} readOnly/>
                                    </div>
                                </div>
                                <div className="form-group mt-3">
                                    <label style={{fontWeight: 'bold'}}>TDS: &nbsp;</label>
                                    <div className="input-group">
                                        <div className="input-group-addon me-2">&#8377;</div>
                                        <input type="number" type="number"
                                               step="0.01"
                                               value={tds}
                                               onChange={handleTdsChange}/>
                                    </div>
                                </div>
                                <div className="form-group mt-3">
                                    <label style={{fontWeight: 'bold'}}>Total: &nbsp;</label>
                                    <div className="input-group">
                                        <div className="input-group-addon me-2">&#8377;</div>
                                        <input type="number" onChange={handleChange} name="tot" value={total} readOnly/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Choose Payment Type</label>
                                <select name="dbType" id="dbType">
                                    <option value="">Select Pay Mode</option>
                                    <option value="Cash">Cash</option>
                                    <option value="Cheque">Cheque</option>
                                    <option value="UPI">UPI</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Details:</label>
                                <textarea
                                    className="no-comma form-control"
                                    tabIndex="0"
                                    name="details"
                                    id="details"
                                    rows={2}
                                    cols={2}
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                         className='mb-5'>
                        <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
                    </div>
                </div>
            </form>
        </section>
    );
};
export default ConsPayment;
